import {
  createSelectorByArray,
  selectT,
  selectFlags,
} from 'app/common/selectors/common';

export const selectShowCategoriesFlyout = state =>
  state.categories.isCategoriesFlyoutDisplayed;
export const selectactiveCategory = state => state.categories.activeCategory;
export const selectcatFlyouts = state => state.categories.catFlyouts;
export const selectCards = state => state.categories.cards;
export const occasionLinksSelector = state => state.categories.occasionLinks;

export const categoriesSelector = createSelectorByArray(
  ['isCategoriesFlyoutDisplayed', selectShowCategoriesFlyout],
  ['catFlyouts', selectcatFlyouts],
  ['activeCategory', selectactiveCategory],
  ['flyoutCards', selectCards],
  ['occasionLinks', occasionLinksSelector],
  ['t', selectT],
  ['flags', selectFlags]
);
